import React from 'react';
import { PartyPopperIcon, GiftIcon, SparklesIcon, HeartIcon, CoffeeIcon, SmileIcon, StarIcon, UsersIcon } from 'lucide-react';
export function SocialProofSection() {
  const items = [{
    text: 'IRL Shopping',
    icon: SparklesIcon
  }, {
    text: 'Vibes',
    icon: PartyPopperIcon
  }, {
    text: 'Group Outing',
    icon: UsersIcon
  }, {
    text: 'Perks',
    icon: StarIcon
  }, {
    text: 'Rewards',
    icon: GiftIcon
  }, {
    text: 'No Coupons',
    icon: CoffeeIcon
  }, {
    text: 'Happiness',
    icon: SmileIcon
  }, {
    text: 'Sharing Treats',
    icon: HeartIcon
  }];
  // Duplicate items to create a seamless loop
  const marqueeItems = [...items, ...items, ...items, ...items];
  return <div className="bg-[#FFFC00] py-4 overflow-hidden border-y-4 border-[#1A1A1A]" data-id="element-524" data-mp="285cew8o58rq">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-525" data-mp="3tepzy5zilyk0">
        {marqueeItems.map((item, index) => <div key={index} className="flex items-center mx-8" data-id="element-526" data-mp="yeh6lsvjatwj" data-mpi={index}>
            <span className="text-[#1A1A1A] font-black uppercase text-2xl tracking-wider" data-id="element-527" data-mp="13e3ls7uxak7z">
              {item.text}
            </span>
            <item.icon className="h-6 w-6 text-[#1A1A1A] ml-8 fill-current" data-id="element-528" data-mp="18erklfpe85cr" />
          </div>)}
      </div>
    </div>;
}